
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as jwteb1eulNNWTKY7VuG8pXMoPmk1rajphIpL5tkZCBiUSUMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/jwt.vue?macro=true";
import { default as riseidB9itbgYmOEbAaGs_hc4aGNbChMFWLDlWiDFzARG22iEMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/riseid.vue?macro=true";
import { default as deposit0lYwKgfldonfpK_45z9oK0ENFy_45jkaSlfxZIKkVx3YiOYMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit.vue?macro=true";
import { default as deposit_45usw8cLo_7jAN_45hR3ZmqJ7HfDgNAX4vLsF0mcWV22lp5P8Meta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit-us.vue?macro=true";
import { default as _91accountId_93_383rTQc5PL5nUrr8a2YfAOcwCEwtLlXkd9H1ouu_45WoMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/external-account/[accountId].vue?macro=true";
import { default as _91accountId_938796ERttKeXxjMj0ukeuDxfdTXpSyumi9jJYNbt6MXQMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/dedicated-address/[accountId].vue?macro=true";
import { default as fundLCSXIdR1AeTGYO8Pd7uk9faj6uzjbYVCW1KAG7sn3uAMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund.vue?macro=true";
import { default as indexQgE2CUKn_45S6GPzIIwnlH8Qsa_45KclT91yNaCylHXuZ74Meta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/index.vue?macro=true";
import { default as riseidLvPqttY_45Ij_45rW8BJC7G4uKN89ejhMHmWBSd2GyrWBqAMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid.vue?macro=true";
import { default as accountZ13EnbYMYnhx04fXLqVkHH7orrAKZW5L7phLLOtxk4EMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/account.vue?macro=true";
import { default as blocked0_M3z5_450KnnoCFTv0G9uvTMTWpPnvDuByXLjVgPLx8IMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/blocked.vue?macro=true";
import { default as referralLsP9L0ZRz5kcwpckJhcruKkTXO2YJxi6XJtI5TbUVYsMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/referral.vue?macro=true";
import { default as security26ZaXv6MvCo_poTCdP47fy_45w2n9sOn8PqnIAThsWr0EMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/security.vue?macro=true";
import { default as sign_45outGbPeW4kPD7GEMZUKa0wJ8HPJ36Ziap884hnoPR8h97MMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-out.vue?macro=true";
import { default as _91accountId_93W8E1HlLz4bO_45YXM2zUuClGqSNDY1xPILvWHQsbLcPtwMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/wire/[accountId].vue?macro=true";
import { default as _91accountId_93kxoYhK__45H5j0tKNypkkWbLoMiSPAksPmRu_45wsTAuZMUMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/blockchain/[accountId].vue?macro=true";
import { default as withdrawFmhci8J3SJ5iOSwFRJ8FFJRL7e3xTjZQm68JWNO2ik0Meta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw.vue?macro=true";
import { default as dashboardQvp7exIxIUTZI_45VNKVSoWOXJZ1m1rHIdcQG2eQR9sJgMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/dashboard.vue?macro=true";
import { default as developer2wtGOIFrhNciO_45zpT8jncbRB4mk79LPjKE9HFY1bXTAMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/developer.vue?macro=true";
import { default as loginJsxc341Xf8SmuHlybcyWRLvJbSFjdomrp68hIEZdthIMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/login.vue?macro=true";
import { default as onboardingiYNfq9v_45q4ly9kP7MdYf9jh9OuA81digvqslo1_45OUugMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/onboarding.vue?macro=true";
import { default as playgroundHtbjnFNKXKsBngOSHEOhoDAAI_45N6bY3P1VkZXkZh38EMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/playground.vue?macro=true";
import { default as _2faJu1_oOKBEE1H5HuIiiRqqgXE5B0k7yjhtCGsKFvWcuIMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/2fa.vue?macro=true";
import { default as indexNdTowKck13zTfz_zQ2GfIi6xGcutZ57TK_O3I0nNv2cMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/tasks/index.vue?macro=true";
import { default as codelbZdCllhVA1_BzGOnNfpWQAkqjtMSNxVBkvtZcLH71gMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/code.vue?macro=true";
import { default as codeCxnC5cUyqX12wYqta_ACI3C67U0iojm8f4iSoCCJ30wMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/code.vue?macro=true";
import { default as indexOBgSvpDOIOz5X3tWc0RZoJDpZCYRzpYAi6LN1_q2UkgMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/index.vue?macro=true";
import { default as registerVx77NrD8Stgfm0rZ058A4NoCCd0phcWw1ynAzYEttdAMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/register.vue?macro=true";
import { default as index9z_45fJ99Dl_XhX8Wr6ZtAvKpSwLFhcxvE8rGCDxM203gMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/index.vue?macro=true";
import { default as _91code_93U7gyiLjSZhF_45y_45KrXJyxSFhYQVXw9wAjbfM4rsHv_YMMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invite/[code].vue?macro=true";
import { default as index1DjzOwfr0oboje0rn1sybpcpcS2azo_cnEwY8_H8G1AMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/index.vue?macro=true";
import { default as sign_45documentyHiqC5_XlXz_45hR63Z_45GvGayWu_454KZgoek2HEqtjhP5UMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-document.vue?macro=true";
import { default as index4iN8LjNwq7oT2ighLbEa9ZV_45Uliz4ZRHKeAsQbGdpwcMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/index.vue?macro=true";
import { default as indexemdjVi_45U_45YkyGrjVNbEUWaQbpygv5izdJIGoevGUyMMMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/index.vue?macro=true";
import { default as importtKklE1X__45MokU7_45dn_lZhX_455gRgJvQZpc0m7A5qotyMMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/import.vue?macro=true";
import { default as directriw4rFDxkPPKWXbvlSQ2ZmuBZgp_45ZWk_45ex7qPj8zdy0Meta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/direct.vue?macro=true";
import { default as sumsubL2MZe9GoujizIuVYWNmJUEUPV3Y_rzv48KNe7zpLpWYMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/sumsub.vue?macro=true";
import { default as warmedKe_45nZLnfyUoc55WCaYl1sxZYD13k9jSAgZ67m61ve5EMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed.vue?macro=true";
import { default as batch_warmedIPuLHJaGWmelAUT2dIW81_AKAnfx00x5_9PjCO3b7XsMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed.vue?macro=true";
import { default as warmed_lightTmqov0oaXbTy0RkU2mfM6ILJcihO88S22OsCTjoluwQMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed_light.vue?macro=true";
import { default as batch_warmed_lightaQ11atqg_45nVK4b6wZN2oGn5S_453d48mV_45BFjRxJJyzloMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed_light.vue?macro=true";
import { default as inviteZeUWnFJ5SQmb_59XhxhUdbzWFgFDF_CNM2T_ZcR9OYIMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite.vue?macro=true";
import { default as indexnmy0OvgCna6bl0_op87qE5B9w1g6IvIrekdyLgnnPZIMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/index.vue?macro=true";
import { default as indexa_45OwVUcCbzMQOpsjCb6FBKYXZkzd5l4LaxxvLR7QiXgMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/index.vue?macro=true";
import { default as waitingfiB90z174ZxXq0KlXPFxgeQ2775DtgKcyoW3lVDF2H4Meta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/waiting.vue?macro=true";
import { default as businessOQtgUza6BuFnlx9WmbUU_C_eESrTpeUVcYdj8KtrTqUMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/business.vue?macro=true";
import { default as callbackOCdtbbx_45xmNAFhJIrYjzsr02kg9jlMr5H89IDGvP2NoMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/callback.vue?macro=true";
import { default as _91id_93hppk3J0c_GUoK5xRsE_DEHoXENAlBmIPrU7BT04FAoMMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/[id].vue?macro=true";
import { default as indexWS8mq6Rc5HJCc8JyRNJfvpLAW7inh_zn5hPplhJhiSIMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/[id]/index.vue?macro=true";
import { default as _91uuid_93JrYDYvg5QCNDhDFhwgm3nBOLlLM1GGMs1ssrlMkp4pwMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/[uuid].vue?macro=true";
import { default as indexLRo1EGHaZwv6Jsl2U01eas8mDX6MDlLd4nqtkeMXLjkMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/index.vue?macro=true";
import { default as indexv3g_45ByN3n9jnIR5A3GBf5b77aBW19BM3mEIzfdi2ziEMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/index.vue?macro=true";
import { default as indexGasDNsgIDwZdTTcWPVmurlg8LM4Y_w0je9HRoTSdmDEMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/index.vue?macro=true";
import { default as optionsX_45EQ9DII9194ZsD13wXw7UX0zF3QkqZ4fUNVa1XXHWoMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/options.vue?macro=true";
import { default as riseid_45erc20_45withdraw0DakuTG5dYUdZ96X_45m8dQ8b22Uje1FjXEn5E5Lz1ymsMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid-erc20-withdraw.vue?macro=true";
import { default as _91token_938zIdF_0EUE3aM_3vm338Z5IU6nqgY1oRmB3FabXt8tMMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/b2b/[token].vue?macro=true";
import { default as indexyL_453bL9zJRIM1jylTHyu5gGZ1hWEj1BamStvYA_45GlNkMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/index.vue?macro=true";
import { default as indexdxAS1m_l6vd19lh0TziLy0O7VACgcauwwV0O0hNk5QoMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/index.vue?macro=true";
import { default as indexawwQv52GSkebS6jbTQgQd55jGJxl7HrSjZRLooa8n0oMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/index.vue?macro=true";
import { default as rampsi4Z_3i3m_45VhllKeIRJDn6bZ34kP_PVMsj8f5i7iPGRcMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/ramps.vue?macro=true";
import { default as classificationIqp2iDwenLmpkvjZnAN2LrSst_45qzvl2mrPif7NiXwY0Meta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/classification.vue?macro=true";
import { default as _91id_93GBDqagPgGokMewP3BbIbajn4WjQjvbXactDIjM53F2gMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/fund/[id].vue?macro=true";
import { default as blockchain_45walletxwJMAxSMroV75Dnxj2_45udaELCfd7Zz4kEw3JECfdgQEMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/blockchain-wallet.vue?macro=true";
import { default as dedicated_45addressDQfcPxt1UtDd1il7HRxLzaHoG_MNZtB0E0Nbg15ta6gMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/dedicated-address.vue?macro=true";
import { default as optionsWBNjYpXt_wWrwJh7QnN3L7vuQ9pV_45hAbQXj461f5Cu4Meta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options.vue?macro=true";
import { default as transaction_45history8eETd4Wp4QY2gSeX5jEw7gVCS8uio3P52nRXZB4V4RoMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/transaction-history.vue?macro=true";
import { default as usJXOo6NW62FANNZDB6l7XaHKTSGztzHLMh2_45KJHZYdsEMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/us.vue?macro=true";
import { default as eur9LCEr7a815EkPVBt_7EIbsDcGo_TPzYZb9_DwZX0RroMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/eur.vue?macro=true";
import { default as gbphRFRisK7UKXjydt2hCOP6bruF1GrelWFu7uT1tikCREMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/gbp.vue?macro=true";
import { default as ngnYZRBYP79zrMerzkhRhcv9uZJiZCblyZFryS4oD6vWA8Meta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/ngn.vue?macro=true";
import { default as brlaGx0ydX0A_45FUc2YIdNc3CqKSWMJ2s7GEUXjzZO58Q85MMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/brla.vue?macro=true";
import { default as forex9zz79Msd03Exx9HyHU6OcRh0hSeETKjX3Sebw_45Z7fQwMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/forex.vue?macro=true";
import { default as kraken4OceHefC3m3ZWjAvfB8h1wANyCPAYdcgLKfPwroas3YMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/kraken.vue?macro=true";
import { default as binancet3omqEQxCbmPAX52_45i7CoxMGV11D698u9CqAI4Hg_45W0Meta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/binance.vue?macro=true";
import { default as coinbase4sy_45oWxjPGkbaVW18Jd5GLOAZyFOTptM15GantsBilMMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase.vue?macro=true";
import { default as internationalGkndkRgn2lzT3EjUQ8bwYbAf_45feZa4mxiTv7zRk_45nCEMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international.vue?macro=true";
import { default as coinbase_wallet6AY7Daa5tdsVz2DHnpoCBCtxXMUNTeoU4nuiN_45oLoqAMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase_wallet.vue?macro=true";
import { default as international_bank0LJCshJ6SdqwiSWHiZHhxiFFk4njnFBi7m6HZ4MnHd0Meta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international_bank.vue?macro=true";
import { default as indexynLgfL47tbMmZk9r_45oU747M6BlStuLQ_Oqwqq52AuHIMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/index.vue?macro=true";
import { default as _91network_93L5YuisBTGpApqjhWp7wCmRGt0_hTNC9AVb_vgJoJXbkMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/[network].vue?macro=true";
import { default as optionsgW_qk2R9dy3xDkpefb63Sx7qPC8nmOJk8t_45lFPEdGxoMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options.vue?macro=true";
import { default as coinbaseZGWkQkWbpMu_45No2IStPX3JlTvQgUKwuXxieBhodJ__45kMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/coinbase.vue?macro=true";
import { default as teamk0PBwlUF8oBl_veyd4uWeAha_fukqe8UA4g5VkbrEGoMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/team.vue?macro=true";
import { default as _91id_93td3j3k1BFu_450NRtfxRftEcrhnTj4kEJ6VLHUs1hBdCQMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/payment/[id].vue?macro=true";
import { default as indexNK31RwmWVw42AGpFrA50AA9vDCf6Hb1NCR7d_45DyBFmQMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/index.vue?macro=true";
import { default as verify_45walletEvlBvdEerTykn3A9HWqFKjGbA_45_45AzN5KSRoVDMOcyq4Meta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/verify-wallet.vue?macro=true";
import { default as pay_schedule0bBf4fBiURyeYX_45_45i8zNmo2hVZpgAcUhRhzdn7walQUMeta } from "/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/[payschedule]/pay_schedule.vue?macro=true";
export default [
  {
    name: "jwt",
    path: "/jwt",
    meta: jwteb1eulNNWTKY7VuG8pXMoPmk1rajphIpL5tkZCBiUSUMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/jwt.vue")
  },
  {
    name: "fund",
    path: "/fund",
    meta: fundLCSXIdR1AeTGYO8Pd7uk9faj6uzjbYVCW1KAG7sn3uAMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund.vue"),
    children: [
  {
    name: "fund-riseid",
    path: "riseid",
    meta: riseidB9itbgYmOEbAaGs_hc4aGNbChMFWLDlWiDFzARG22iEMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/riseid.vue")
  },
  {
    name: "fund-deposit",
    path: "deposit",
    meta: deposit0lYwKgfldonfpK_45z9oK0ENFy_45jkaSlfxZIKkVx3YiOYMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit.vue")
  },
  {
    name: "fund-deposit-us",
    path: "deposit-us",
    meta: deposit_45usw8cLo_7jAN_45hR3ZmqJ7HfDgNAX4vLsF0mcWV22lp5P8Meta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit-us.vue")
  },
  {
    name: "fund-external-account-accountId",
    path: "external-account/:accountId()",
    meta: _91accountId_93_383rTQc5PL5nUrr8a2YfAOcwCEwtLlXkd9H1ouu_45WoMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/external-account/[accountId].vue")
  },
  {
    name: "fund-dedicated-address-accountId",
    path: "dedicated-address/:accountId()",
    meta: _91accountId_938796ERttKeXxjMj0ukeuDxfdTXpSyumi9jJYNbt6MXQMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/dedicated-address/[accountId].vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    meta: indexQgE2CUKn_45S6GPzIIwnlH8Qsa_45KclT91yNaCylHXuZ74Meta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/index.vue")
  },
  {
    name: "riseid",
    path: "/riseid",
    meta: riseidLvPqttY_45Ij_45rW8BJC7G4uKN89ejhMHmWBSd2GyrWBqAMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: accountZ13EnbYMYnhx04fXLqVkHH7orrAKZW5L7phLLOtxk4EMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/account.vue")
  },
  {
    name: "blocked",
    path: "/blocked",
    meta: blocked0_M3z5_450KnnoCFTv0G9uvTMTWpPnvDuByXLjVgPLx8IMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/blocked.vue")
  },
  {
    name: "referral",
    path: "/referral",
    meta: referralLsP9L0ZRz5kcwpckJhcruKkTXO2YJxi6XJtI5TbUVYsMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/referral.vue")
  },
  {
    name: "security",
    path: "/security",
    meta: security26ZaXv6MvCo_poTCdP47fy_45w2n9sOn8PqnIAThsWr0EMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/security.vue")
  },
  {
    name: "sign-out",
    path: "/sign-out",
    meta: sign_45outGbPeW4kPD7GEMZUKa0wJ8HPJ36Ziap884hnoPR8h97MMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-out.vue")
  },
  {
    name: "withdraw",
    path: "/withdraw",
    meta: withdrawFmhci8J3SJ5iOSwFRJ8FFJRL7e3xTjZQm68JWNO2ik0Meta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw.vue"),
    children: [
  {
    name: "withdraw-wire-accountId",
    path: "wire/:accountId()",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/wire/[accountId].vue")
  },
  {
    name: "withdraw-blockchain-accountId",
    path: "blockchain/:accountId()",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/blockchain/[accountId].vue")
  }
]
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardQvp7exIxIUTZI_45VNKVSoWOXJZ1m1rHIdcQG2eQR9sJgMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/dashboard.vue")
  },
  {
    name: "developer",
    path: "/developer",
    meta: developer2wtGOIFrhNciO_45zpT8jncbRB4mk79LPjKE9HFY1bXTAMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/developer.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/login.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboardingiYNfq9v_45q4ly9kP7MdYf9jh9OuA81digvqslo1_45OUugMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/onboarding.vue")
  },
  {
    name: "playground",
    path: "/playground",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/playground.vue")
  },
  {
    name: "sign-in-2fa",
    path: "/sign-in/2fa",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/2fa.vue")
  },
  {
    name: "tasks",
    path: "/tasks",
    meta: indexNdTowKck13zTfz_zQ2GfIi6xGcutZ57TK_O3I0nNv2cMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/tasks/index.vue")
  },
  {
    name: "sign-in-code",
    path: "/sign-in/code",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/code.vue")
  },
  {
    name: "sign-up-code",
    path: "/sign-up/code",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/code.vue")
  },
  {
    name: "talent",
    path: "/talent",
    meta: indexOBgSvpDOIOz5X3tWc0RZoJDpZCYRzpYAi6LN1_q2UkgMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/index.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/register.vue")
  },
  {
    name: "clients",
    path: "/clients",
    meta: index9z_45fJ99Dl_XhX8Wr6ZtAvKpSwLFhcxvE8rGCDxM203gMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/index.vue")
  },
  {
    name: "invite-code",
    path: "/invite/:code()",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invite/[code].vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: index1DjzOwfr0oboje0rn1sybpcpcS2azo_cnEwY8_H8G1AMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/index.vue")
  },
  {
    name: "sign-document",
    path: "/sign-document",
    meta: sign_45documentyHiqC5_XlXz_45hR63Z_45GvGayWu_454KZgoek2HEqtjhP5UMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-document.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index4iN8LjNwq7oT2ighLbEa9ZV_45Uliz4ZRHKeAsQbGdpwcMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/index.vue")
  },
  {
    name: "talent-import",
    path: "/talent/import",
    meta: importtKklE1X__45MokU7_45dn_lZhX_455gRgJvQZpc0m7A5qotyMMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/import.vue")
  },
  {
    name: "talent-invite",
    path: "/talent/invite",
    meta: inviteZeUWnFJ5SQmb_59XhxhUdbzWFgFDF_CNM2T_ZcR9OYIMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite.vue"),
    children: [
  {
    name: "talent-invite-direct",
    path: "direct",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/direct.vue")
  },
  {
    name: "talent-invite-sumsub",
    path: "sumsub",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/sumsub.vue")
  },
  {
    name: "talent-invite-warmed",
    path: "warmed",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed.vue")
  },
  {
    name: "talent-invite-batch_warmed",
    path: "batch_warmed",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed.vue")
  },
  {
    name: "talent-invite-warmed_light",
    path: "warmed_light",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed_light.vue")
  },
  {
    name: "talent-invite-batch_warmed_light",
    path: "batch_warmed_light",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed_light.vue")
  }
]
  },
  {
    name: "invoices",
    path: "/invoices",
    meta: indexnmy0OvgCna6bl0_op87qE5B9w1g6IvIrekdyLgnnPZIMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/index.vue")
  },
  {
    name: "documents",
    path: "/documents",
    meta: indexa_45OwVUcCbzMQOpsjCb6FBKYXZkzd5l4LaxxvLR7QiXgMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/index.vue")
  },
  {
    name: "sign-up-waiting",
    path: "/sign-up/waiting",
    meta: waitingfiB90z174ZxXq0KlXPFxgeQ2775DtgKcyoW3lVDF2H4Meta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/waiting.vue")
  },
  {
    name: "profile-business",
    path: "/profile/business",
    meta: businessOQtgUza6BuFnlx9WmbUU_C_eESrTpeUVcYdj8KtrTqUMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/business.vue")
  },
  {
    name: "sign-in-callback",
    path: "/sign-in/callback",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/callback.vue")
  },
  {
    name: "invoices-add-id",
    path: "/invoices/add/:id()",
    meta: _91id_93hppk3J0c_GUoK5xRsE_DEHoXENAlBmIPrU7BT04FAoMMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/[id].vue")
  },
  {
    name: "talent-id",
    path: "/talent/:id()",
    meta: indexWS8mq6Rc5HJCc8JyRNJfvpLAW7inh_zn5hPplhJhiSIMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/[id]/index.vue")
  },
  {
    name: "auth-invite-uuid",
    path: "/auth/invite/:uuid()",
    meta: _91uuid_93JrYDYvg5QCNDhDFhwgm3nBOLlLM1GGMs1ssrlMkp4pwMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/[uuid].vue")
  },
  {
    name: "clients-id",
    path: "/clients/:id()",
    meta: indexLRo1EGHaZwv6Jsl2U01eas8mDX6MDlLd4nqtkeMXLjkMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/index.vue")
  },
  {
    name: "invoices-add",
    path: "/invoices/add",
    meta: indexv3g_45ByN3n9jnIR5A3GBf5b77aBW19BM3mEIzfdi2ziEMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/index.vue")
  },
  {
    name: "subscription",
    path: "/subscription",
    meta: indexGasDNsgIDwZdTTcWPVmurlg8LM4Y_w0je9HRoTSdmDEMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/index.vue")
  },
  {
    name: "subscription-options",
    path: "/subscription/options",
    meta: optionsX_45EQ9DII9194ZsD13wXw7UX0zF3QkqZ4fUNVa1XXHWoMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/options.vue")
  },
  {
    name: "riseid-erc20-withdraw",
    path: "/riseid-erc20-withdraw",
    meta: riseid_45erc20_45withdraw0DakuTG5dYUdZ96X_45m8dQ8b22Uje1FjXEn5E5Lz1ymsMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid-erc20-withdraw.vue")
  },
  {
    name: "auth-invite-b2b-token",
    path: "/auth/invite/b2b/:token()",
    meta: _91token_938zIdF_0EUE3aM_3vm338Z5IU6nqgY1oRmB3FabXt8tMMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/b2b/[token].vue")
  },
  {
    name: "management-company",
    path: "/management/company",
    meta: indexyL_453bL9zJRIM1jylTHyu5gGZ1hWEj1BamStvYA_45GlNkMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/index.vue")
  },
  {
    name: "accounts-add-funding",
    path: "/accounts/add-funding",
    meta: indexdxAS1m_l6vd19lh0TziLy0O7VACgcauwwV0O0hNk5QoMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/index.vue")
  },
  {
    name: "accounts-add-withdraw",
    path: "/accounts/add-withdraw",
    meta: indexawwQv52GSkebS6jbTQgQd55jGJxl7HrSjZRLooa8n0oMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/index.vue")
  },
  {
    name: "accounts-add-withdraw-ramps",
    path: "/accounts/add-withdraw/ramps",
    meta: rampsi4Z_3i3m_45VhllKeIRJDn6bZ34kP_PVMsj8f5i7iPGRcMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/ramps.vue")
  },
  {
    name: "clients-id-classification",
    path: "/clients/:id()/classification",
    meta: classificationIqp2iDwenLmpkvjZnAN2LrSst_45qzvl2mrPif7NiXwY0Meta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/classification.vue")
  },
  {
    name: "payments-receipts-fund-id",
    path: "/payments/receipts/fund/:id()",
    meta: _91id_93GBDqagPgGokMewP3BbIbajn4WjQjvbXactDIjM53F2gMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/fund/[id].vue")
  },
  {
    name: "accounts-add-funding-options",
    path: "/accounts/add-funding/options",
    meta: optionsWBNjYpXt_wWrwJh7QnN3L7vuQ9pV_45hAbQXj461f5Cu4Meta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options.vue"),
    children: [
  {
    name: "accounts-add-funding-options-blockchain-wallet",
    path: "blockchain-wallet",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/blockchain-wallet.vue")
  },
  {
    name: "accounts-add-funding-options-dedicated-address",
    path: "dedicated-address",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/dedicated-address.vue")
  }
]
  },
  {
    name: "payments-transaction-history",
    path: "/payments/transaction-history",
    meta: transaction_45history8eETd4Wp4QY2gSeX5jEw7gVCS8uio3P52nRXZB4V4RoMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/transaction-history.vue")
  },
  {
    name: "accounts-add-withdraw-options",
    path: "/accounts/add-withdraw/options",
    meta: optionsgW_qk2R9dy3xDkpefb63Sx7qPC8nmOJk8t_45lFPEdGxoMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options.vue"),
    children: [
  {
    name: "accounts-add-withdraw-options-us",
    path: "us",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/us.vue")
  },
  {
    name: "accounts-add-withdraw-options-eur",
    path: "eur",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/eur.vue")
  },
  {
    name: "accounts-add-withdraw-options-gbp",
    path: "gbp",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/gbp.vue")
  },
  {
    name: "accounts-add-withdraw-options-ngn",
    path: "ngn",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/ngn.vue")
  },
  {
    name: "accounts-add-withdraw-options-brla",
    path: "brla",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/brla.vue")
  },
  {
    name: "accounts-add-withdraw-options-forex",
    path: "forex",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/forex.vue")
  },
  {
    name: "accounts-add-withdraw-options-kraken",
    path: "kraken",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/kraken.vue")
  },
  {
    name: "accounts-add-withdraw-options-binance",
    path: "binance",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/binance.vue")
  },
  {
    name: "accounts-add-withdraw-options-coinbase",
    path: "coinbase",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase.vue")
  },
  {
    name: "accounts-add-withdraw-options-international",
    path: "international",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international.vue")
  },
  {
    name: "accounts-add-withdraw-options-coinbase_wallet",
    path: "coinbase_wallet",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase_wallet.vue")
  },
  {
    name: "accounts-add-withdraw-options-international_bank",
    path: "international_bank",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international_bank.vue")
  },
  {
    name: "accounts-add-withdraw-options-blockchain-wallet",
    path: "blockchain-wallet",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/index.vue")
  },
  {
    name: "accounts-add-withdraw-options-blockchain-wallet-network",
    path: "blockchain-wallet/:network()",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/[network].vue")
  }
]
  },
  {
    name: "accounts-add-callback-coinbase",
    path: "/accounts/add/callback/coinbase",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/coinbase.vue")
  },
  {
    name: "management-company-create-team",
    path: "/management/company/create/team",
    meta: teamk0PBwlUF8oBl_veyd4uWeAha_fukqe8UA4g5VkbrEGoMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/team.vue")
  },
  {
    name: "payments-receipts-payment-id",
    path: "/payments/receipts/payment/:id()",
    meta: _91id_93td3j3k1BFu_450NRtfxRftEcrhnTj4kEJ6VLHUs1hBdCQMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/payment/[id].vue")
  },
  {
    name: "management-company-create",
    path: "/management/company/create",
    meta: indexNK31RwmWVw42AGpFrA50AA9vDCf6Hb1NCR7d_45DyBFmQMeta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/index.vue")
  },
  {
    name: "accounts-add-callback-verify-wallet",
    path: "/accounts/add/callback/verify-wallet",
    meta: verify_45walletEvlBvdEerTykn3A9HWqFKjGbA_45_45AzN5KSRoVDMOcyq4Meta || {},
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/verify-wallet.vue")
  },
  {
    name: "documents-payschedule-pay_schedule",
    path: "/documents/:payschedule()/pay_schedule",
    component: () => import("/data/runners/gh1207/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/[payschedule]/pay_schedule.vue")
  }
]